import { SKYROVER_COLORS } from '@/theme/skyroverTheme';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { useEffect, useState } from 'react';

interface SaveProjectDialogProps {
  open: boolean;
  initialName: string;
  title?: string;
  onClose: () => void;
  onSave: (name: string) => void;
}

export function SaveProjectDialog({
  open,
  initialName,
  title = 'Save Project',
  onClose,
  onSave,
}: SaveProjectDialogProps) {
  const [name, setName] = useState(initialName);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setName(initialName);
      setError('');
    }
  }, [open, initialName]);

  const handleSave = () => {
    const trimmed = name.trim();
    if (!trimmed) {
      setError('Project name is required.');
      return;
    }
    if (trimmed.length > 128) {
      setError('Project name must be 128 characters or fewer.');
      return;
    }
    onSave(trimmed);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          margin="dense"
          label="Project name"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            if (error) {
              setError('');
            }
          }}
          error={Boolean(error)}
          helperText={
            error ||
            'Choose a name, then your browser will ask where to save the .skyrover file.'
          }
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleSave();
            }
          }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSave}
          sx={{
            bgcolor: SKYROVER_COLORS.header,
            '&:hover': { bgcolor: SKYROVER_COLORS.headerHover },
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
